/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { Button, Modal, Checkbox } from "react-materialize";
import $ from "jquery";
import Html from "../../utils/Html";
//import BtnExportSubmit from "./modal.export.btn.submit";
import html2canvas from "html2canvas";

export default function ModalDownload() {
  const [itemData, setItemData] = useState({
    data: {},
    type: "",
    status: "",
    err: 0,
    err_msg: "" });
  //const [exportType, setExportType] = useState({displayed: 0, all: 1, key: 1});
  let header = "Download to PNG";
  let content = "";
  let footer = "";
  let btns = [<div className="header">{header}</div>];
  let modalCSS = {};
  modalCSS.height = "240px";
  const handleEvents = {
    BtnDownload: {
      OnComplete: function () {
        setItemData({ data: {}, type: "", status: "", err: 0, err_msg: "" });
        //setExportType({displayed: 0, all: 1, key: 1});
      } },
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setItemData({ data: {}, type: "", status: "", err: 0, err_msg: "" });
    },
    OnSubmit: function (evt) {
      // Form Submit
      evt.preventDefault();
    } };
  const downloadPNG = async () => {
    const tmpElemId = "tmp-tree";
    const padding = 40; // ปรับได้
    const clone = $(".organizational-chart").clone();

    // เตรียม div ชั่วคราว + wrapper ใส่ padding
    const tmpElem = document.createElement("div");
    $(tmpElem).attr("id", tmpElemId).addClass("capture-for-download").css({
      position: "absolute",
      left: "-99999px",
      top: "-99999px",
      display: "flex",
      justifyContent: "left" });

    const wrapper = document.createElement("div");
    $(wrapper).css({
      padding: `${padding}px`,
      background: "#fff",
      display: "inline-block" });
    $(wrapper).append(clone);
    $(tmpElem).html(wrapper);
    $("#tmp-print").html(tmpElem);

    // ให้ภาพพนักงาน background-size cover
    $(`#${tmpElemId} .staff .image-circle`).css({ "background-size": "cover" });

    const chartElem = wrapper.querySelector(".organizational-chart");
    const w =
      (chartElem?.scrollWidth ||
        chartElem?.clientWidth ||
        $(chartElem).innerWidth()) +
      padding * 2;
    const h =
      (chartElem?.scrollHeight ||
        chartElem?.clientHeight ||
        $(chartElem).innerHeight()) +
      padding * 2 +
      30;

    // จำกัดขนาดสูงสุด ลด scale ถ้ากราฟใหญ่มาก
    const maxDimension = 12000;
    const baseScale =
      Math.max(w, h) > maxDimension ? maxDimension / Math.max(w, h) : 1;
    const scale =
      baseScale === 1
        ? Math.min(window.devicePixelRatio || 1, 2)
        : Math.max(baseScale, 0.4);

    try {
      const canvas = await html2canvas(
        document.querySelector(`#${tmpElemId}`),
        {
          width: w,
          height: h,
          windowWidth: w,
          windowHeight: h,
          scrollX: 0,
          scrollY: 0,
          scale,
          backgroundColor: "#fff",
          useCORS: true,
          allowTaint: false,
          logging: false }
      );

      // ใช้ toBlob ลดโอกาสไฟล์ว่าง
      await new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error("Empty blob"));
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.download = "organization.png";
            a.href = url;
            a.target = "_blank";
            a.click();
            URL.revokeObjectURL(url);
            resolve();
          },
          "image/png",
          1.0
        );
      });

      setItemData({ data: {}, status: "success", err: 0, err_msg: "" });
    } catch (e) {
      console.error("Download PNG failed", e);
      setItemData({
        data: {},
        status: "",
        err: 1,
        err_msg: "Download failed, please try again." });
    } finally {
      $(`#${tmpElemId}`).remove();
    }
  };

  // const downloadPNG = function () {
  //   console.log("Print");
  //   const tmpElemId = "tmp-tree";
  //   let clone = $(".organizational-chart").clone();
  //   let tmpElem = document.createElement("div");
  //   $(tmpElem)
  //     .attr("id", "tmp-tree")
  //     .addClass("capture-for-download")
  //     .css({
  //       position: "absolute",
  //       left: "-99999px",
  //       top: "-99999px",
  //       display: "flex",
  //       justifyContent: "left",
  //     })
  //     .html(clone);
  //   $("#tmp-print").html(tmpElem);
  //   $("#" + tmpElemId + " .staff .image-circle").css({
  //     "background-size": "cover",
  //   });
  //   let canvasWidth = $(
  //     "#" + tmpElemId + " .organizational-chart"
  //   ).innerWidth();
  //   let canvasHeight =
  //     $("#" + tmpElemId + " .organizational-chart").innerHeight() + 30;
  //   //console.log(canvasWidth, canvasHeight);
  //   html2canvas(document.querySelector("#" + tmpElemId), {
  //     logging: true,
  //     letterRendering: 1,
  //     allowTaint: false,
  //     useCORS: true,
  //     width: canvasWidth,
  //     height: canvasHeight,
  //     backgroundColor: "#fff",
  //   }).then((canvas) => {
  //     var ctx = canvas.getContext("2d");
  //     ctx.webkitImageSmoothingEnabled = false;
  //     ctx.mozImageSmoothingEnabled = false;
  //     ctx.imageSmoothingEnabled = false;
  //     var anchorTag = document.createElement("a");
  //     document.body.appendChild(anchorTag);
  //     //document.getElementById("preview-print").appendChild(canvas);
  //     anchorTag.download = "organization.png";
  //     //anchorTag.href = canvas.toDataURL('image/jpeg');
  //     anchorTag.href = canvas.toDataURL("image/png", 1.0);
  //     anchorTag.target = "_blank";
  //     anchorTag.click();
  //     $("#" + tmpElemId).remove();
  //     setItemData({
  //       data: {},
  //       status: "success",
  //       err: 0,
  //       err_msg: "",
  //     });
  //   });
  //   return;
  // };
  useEffect(() => {
    $("#main-content").on("click", "#btn-download-chart", function (evt) {
      setItemData({
        data: {},
        status: "inprocess",
        err: 0,
        err_msg: "" });
      downloadPNG();
    });
  }, []);

  if (itemData.status === "") {
    return "";
  } else if ("err" in itemData && itemData.err === 1) {
    modalCSS.height = "170px";
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );
    content = (
      <div className="text-error">Fetch request error: {itemData.err_msg}</div>
    );
  } else if (itemData.status != "success") {
    content = (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto" } }}
        />
      </div>
    );
  } else {
    //console.log("Edit", itemData);
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );
    /*content = <div className="modal-content-outer">
            <div key="modal-content-inner" className="modal-content-inner">
                <Feature.Content 
                    data={exportType} 
                    handleEvents={handleEvents.CheckboxExport} />
            </div>
            <div key="modal-loading" className="modal-loading hide">
                <Html.Preloading addon={{
                    css: {
                        position: "absolute",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        margin: "auto"
                    }
                }} />
            </div>
        </div>
        footer = <div className="modal-footer-bottom">
            <span className="modal-error-text hide"></span>
            <BtnExportSubmit 
                events={handleEvents.BtnExport} 
                header={header} />
        </div>*/
    content = (
      <div className="modal-content-outer">
        <div key="modal-content-inner" className="modal-content-inner">
          <a className="btn-floating waves-effect waves-light">
            <i className="material-icons">check</i>
          </a>
          <span style={{ marginLeft: "20px" }}>
            Your Organization Chart has been downloaded.
          </span>
        </div>
        <div key="modal-loading" className="modal-loading hide">
          <Html.Preloading
            addon={{
              css: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                margin: "auto" } }}
          />
        </div>
      </div>
    );
    footer = "";
  }

  return (
    <Modal
      actions={btns}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user modal-user-footer"
      id="modal-user-download"
      open={true}
      options={{
        dismissible: true,
        endingTop: "10%",
        inDuration: 250,
        onCloseEnd: null,
        onCloseStart: handleEvents.OnClose,
        onOpenEnd: null,
        onOpenStart: null,
        opacity: 0.5,
        outDuration: 250,
        preventScrolling: true,
        startingTop: "5%" }}
      root={document.getElementById("root")}
      style={modalCSS}
    >
      {content}
      {footer}
    </Modal>
  );
}

const Feature = {};
Feature.Content = function ({ data, handleEvents }) {
  let content = [];
  content.push(
    <div
      key="content-export_displayed"
      className="row"
      id="content-export_displayed"
      style={{ width: "80%" }}
    >
      <div
        className="col s4 title"
        style={{ marginTop: "5px", textAlign: "right" }}
      >
        <Checkbox
          filledIn
          checked={data.displayed == 1 ? true : false}
          key={"export-column-displayed-" + data.key}
          key-number={data.key}
          name="export-column-displayed"
          label=""
          value={"displayed"}
          onChange={handleEvents.OnChange}
        />
      </div>
      <span
        className="col s8 desc"
        style={{ lineHeight: "30px", height: "30px" }}
      >
        Columns as displayed
      </span>
    </div>
  );
  content.push(
    <div
      key="content-export_all"
      className="row"
      id="content-export_all"
      style={{ width: "80%" }}
    >
      <div
        className="col s4 title"
        style={{ marginTop: "5px", textAlign: "right" }}
      >
        <Checkbox
          filledIn
          checked={data.all == 1 ? true : false}
          key={"export-column-all-" + data.key}
          key-number={data.key}
          name="export-column-all"
          label=""
          value="all"
          onChange={handleEvents.OnChange}
        />
      </div>
      <span
        className="col s8 desc"
        style={{ lineHeight: "30px", height: "30px" }}
      >
        All Columns
      </span>
    </div>
  );
  return <div style={{ paddingTop: "15px" }}>{content}</div>;
};

